import { FoodItem, Category } from '../types';

export const categories: Category[] = [
  { id: 'burgers', name: 'Бургеры', icon: '🍔' },
  { id: 'pizza', name: 'Пицца', icon: '🍕' },
  { id: 'pasta', name: 'Паста', icon: '🍝' },
  { id: 'salads', name: 'Салаты', icon: '🥗' },
  { id: 'desserts', name: 'Десерты', icon: '🍰' },
  { id: 'drinks', name: 'Напитки', icon: '🥤' },
];

export const foodItems: FoodItem[] = [
  // Бургеры
  {
    id: '1',
    name: 'Классический бургер',
    description: 'Сочный бургер с говяжьей котлетой, сыром чеддер, салатом и помидорами',
    price: 350,
    image: 'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=400',
    category: 'burgers',
    rating: 4.8,
    preparationTime: 15,
    ingredients: [
      { id: 'beef', name: 'Говядина', price: 0, isDefault: true },
      { id: 'cheese', name: 'Сыр чеддер', price: 0, isDefault: true },
      { id: 'lettuce', name: 'Салат', price: 0, isDefault: true },
      { id: 'tomato', name: 'Помидоры', price: 0, isDefault: true },
      { id: 'onion', name: 'Лук', price: 0, isDefault: true },
      { id: 'ketchup', name: 'Кетчуп', price: 0, isDefault: true },
      { id: 'mayo', name: 'Майонез', price: 0, isDefault: true },
      { id: 'bacon', name: 'Бекон', price: 50, isDefault: false },
      { id: 'jalapenos', name: 'Халапеньо', price: 30, isDefault: false },
    ],
    isVegetarian: false,
    isVegan: false,
    isGlutenFree: false,
  },
  {
    id: '2',
    name: 'Чикен бургер',
    description: 'Нежный куриный бургер с хрустящей корочкой и свежими овощами',
    price: 320,
    image: 'https://images.unsplash.com/photo-1572802419224-296b0aeee0d9?w=400',
    category: 'burgers',
    rating: 4.6,
    preparationTime: 12,
    ingredients: [
      { id: 'chicken', name: 'Курица', price: 0, isDefault: true },
      { id: 'cheese', name: 'Сыр', price: 0, isDefault: true },
      { id: 'lettuce', name: 'Салат', price: 0, isDefault: true },
      { id: 'tomato', name: 'Помидоры', price: 0, isDefault: true },
      { id: 'onion', name: 'Лук', price: 0, isDefault: true },
      { id: 'sauce', name: 'Соус', price: 0, isDefault: true },
    ],
    isVegetarian: false,
    isVegan: false,
    isGlutenFree: false,
  },
  {
    id: '3',
    name: 'Веган бургер',
    description: 'Вкусный бургер из растительной котлеты с овощами',
    price: 290,
    image: 'https://images.unsplash.com/photo-1551782450-17144efb5723?w=400',
    category: 'burgers',
    rating: 4.4,
    preparationTime: 10,
    ingredients: [
      { id: 'veggie_patty', name: 'Растительная котлета', price: 0, isDefault: true },
      { id: 'avocado', name: 'Авокадо', price: 0, isDefault: true },
      { id: 'lettuce', name: 'Салат', price: 0, isDefault: true },
      { id: 'tomato', name: 'Томаты', price: 0, isDefault: true },
      { id: 'cucumber', name: 'Огурец', price: 0, isDefault: true },
      { id: 'vegan_sauce', name: 'Веганский соус', price: 0, isDefault: true },
    ],
    isVegetarian: true,
    isVegan: true,
    isGlutenFree: true,
  },

  // Пицца
  {
    id: '4',
    name: 'Маргарита',
    description: 'Классическая пицца с томатным соусом, моцареллой и базиликом',
    price: 450,
    image: 'https://images.unsplash.com/photo-1604382354936-07c5d9983bd3?w=400',
    category: 'pizza',
    rating: 4.9,
    preparationTime: 20,
    ingredients: [
      { id: 'tomato_sauce', name: 'Томатный соус', price: 0, isDefault: true },
      { id: 'mozzarella', name: 'Моцарелла', price: 0, isDefault: true },
      { id: 'basil', name: 'Базилик', price: 0, isDefault: true },
      { id: 'olive_oil', name: 'Оливковое масло', price: 0, isDefault: true },
    ],
    isVegetarian: true,
    isVegan: false,
    isGlutenFree: false,
  },
  {
    id: '5',
    name: 'Пепперони',
    description: 'Острая пицца с пепперони, сыром и томатным соусом',
    price: 520,
    image: 'https://images.unsplash.com/photo-1628840042765-356cda07504e?w=400',
    category: 'pizza',
    rating: 4.7,
    preparationTime: 18,
    ingredients: [
      { id: 'tomato_sauce', name: 'Томатный соус', price: 0, isDefault: true },
      { id: 'mozzarella', name: 'Моцарелла', price: 0, isDefault: true },
      { id: 'pepperoni', name: 'Пепперони', price: 0, isDefault: true },
      { id: 'spices', name: 'Специи', price: 0, isDefault: true },
    ],
    isVegetarian: false,
    isVegan: false,
    isGlutenFree: false,
  },

  // Паста
  {
    id: '6',
    name: 'Карбонара',
    description: 'Кремовая паста с беконом, яйцами и сыром пармезан',
    price: 380,
    image: 'https://images.unsplash.com/photo-1551183053-bf91a1d81141?w=400',
    category: 'pasta',
    rating: 4.8,
    preparationTime: 15,
    ingredients: [
      { id: 'spaghetti', name: 'Спагетти', price: 0, isDefault: true },
      { id: 'bacon', name: 'Бекон', price: 0, isDefault: true },
      { id: 'eggs', name: 'Яйца', price: 0, isDefault: true },
      { id: 'parmesan', name: 'Пармезан', price: 0, isDefault: true },
      { id: 'cream', name: 'Сливки', price: 0, isDefault: true },
      { id: 'pepper', name: 'Черный перец', price: 0, isDefault: true },
    ],
    isVegetarian: false,
    isVegan: false,
    isGlutenFree: false,
  },

  // Салаты
  {
    id: '7',
    name: 'Цезарь с курицей',
    description: 'Свежий салат с курицей, пармезаном и хрустящими крутонами',
    price: 280,
    image: 'https://images.unsplash.com/photo-1550304943-4f24f54ddde9?w=400',
    category: 'salads',
    rating: 4.5,
    preparationTime: 8,
    ingredients: [
      { id: 'chicken', name: 'Курица', price: 0, isDefault: true },
      { id: 'romaine', name: 'Салат ромэн', price: 0, isDefault: true },
      { id: 'parmesan', name: 'Пармезан', price: 0, isDefault: true },
      { id: 'croutons', name: 'Крутоны', price: 0, isDefault: true },
      { id: 'caesar', name: 'Соус цезарь', price: 0, isDefault: true },
    ],
    isVegetarian: false,
    isVegan: false,
    isGlutenFree: false,
  },

  // Десерты
  {
    id: '8',
    name: 'Тирамису',
    description: 'Классический итальянский десерт с кофе и маскарпоне',
    price: 220,
    image: 'https://images.unsplash.com/photo-1571877227200-a0d98ea607e9?w=400',
    category: 'desserts',
    rating: 4.9,
    preparationTime: 5,
    ingredients: [
      { id: 'mascarpone', name: 'Маскарпоне', price: 0, isDefault: true },
      { id: 'sponge', name: 'Бисквит', price: 0, isDefault: true },
      { id: 'coffee', name: 'Кофе', price: 0, isDefault: true },
      { id: 'cocoa', name: 'Какао', price: 0, isDefault: true },
      { id: 'eggs', name: 'Яйца', price: 0, isDefault: true },
    ],
    isVegetarian: true,
    isVegan: false,
    isGlutenFree: false,
  },

  // Напитки
  {
    id: '9',
    name: 'Мохито',
    description: 'Освежающий коктейль с мятой, лаймом и содовой',
    price: 180,
    image: 'https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?w=400',
    category: 'drinks',
    rating: 4.6,
    preparationTime: 3,
    ingredients: [
      { id: 'mint', name: 'Мята', price: 0, isDefault: true },
      { id: 'lime', name: 'Лайм', price: 0, isDefault: true },
      { id: 'rum', name: 'Ром', price: 0, isDefault: true },
      { id: 'soda', name: 'Содовая', price: 0, isDefault: true },
      { id: 'sugar', name: 'Сахар', price: 0, isDefault: true },
    ],
    isVegetarian: true,
    isVegan: true,
    isGlutenFree: true,
  },
];
